import { ResultsOwnershipChartPlacement } from '../../types'
import ChartPlacementForm from './ChartPlacementForm'
import { LABELS } from '../../pages/AccountabilityCharts/labels'

interface Props {
  chart: ResultsOwnershipChartPlacement
  person: { id: number; full_name: string }
  onClose: () => void
}

/** Dialog wrapper around the shared placement step, used from a People row. */
export default function ChartPlacementModal({ chart, person, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-elevated w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
        <div className="px-6 py-4 border-b border-stone/20 flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-text-primary font-heading">Add to {LABELS.feature}</h2>
            <p className="text-sm text-text-secondary mt-0.5">
              Place {person.full_name} on {chart.name}.
            </p>
          </div>
          <button onClick={onClose} className="text-text-secondary hover:text-text-primary transition-colors" aria-label="Close">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6">
          <ChartPlacementForm
            chart={chart}
            person={person}
            onCancel={onClose}
            onPlaced={onClose}
          />
        </div>
      </div>
    </div>
  )
}
